import {Component, Input, OnInit} from '@angular/core';
import {SelectColumn} from '../../model/column/select-column';
import {DatatableColumn} from '../../model/column/datatable-column';
import {FormGroup} from '@angular/forms';
import {Option} from 'nc-shared';
import {EnumUtils} from 'nc-utils';
import {AlignColumnsEnumeration} from '../../model/column/align-columns.enumeration';

@Component({
  selector: 'nc-select-filter',
  templateUrl: './nc-select-filter.component.html',
  styleUrls: ['./nc-select-filter.component.scss']
})
export class NcSelectFilterComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() column: DatatableColumn;
  selectColumn: SelectColumn;
  items: Array<Option>;
  readonly alignmentType = AlignColumnsEnumeration;
  alignClass: string;

  ngOnInit(): void {
    this.selectColumn = this.column as SelectColumn;
    this.items = EnumUtils.toItems(this.selectColumn.enumeration);

    switch (this.selectColumn.alignment) {
      case this.alignmentType.ALIGN_LEFT:
        this.alignClass = 'align-left';
        break;
      case this.alignmentType.ALIGN_CENTER:
        this.alignClass = 'align-center';
        break;
      case this.alignmentType.ALIGN_RIGHT:
        this.alignClass = 'align-right';
        break;
    }
  }
}
